import React from 'react';
import { StarIcon } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  age: number;
  role: string;
  location: string;
  text: string;
}
export function TestimonialCard({
  name,
  age,
  role,
  location,
  text
}: TestimonialCardProps) {
  const initials = name.split(' ').map(n => n[0]).join('');
  return <div className="bg-white rounded-lg shadow-lg p-6 border-t-4 border-green-600" data-id="element-385">
      <div className="flex gap-1 mb-4" data-id="element-386">
        {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-387" />)}
      </div>

      <p className="text-gray-700 mb-6 italic" data-id="element-388">"{text}"</p>

      <div className="flex items-center gap-3" data-id="element-389">
        <div className="w-12 h-12 rounded-full bg-gradient-to-br from-green-600 to-green-800 flex items-center justify-center text-white font-bold" data-id="element-390">
          {initials}
        </div>
        <div data-id="element-391">
          <p className="font-bold text-gray-900" data-id="element-392">
            {name}, {age} años
          </p>
          <p className="text-sm text-gray-600" data-id="element-393">{role}</p>
          <p className="text-xs text-gray-500" data-id="element-394">{location}</p>
        </div>
      </div>
    </div>;
}